import axios from '../../plugins/axios';
import jquery from 'jquery';

export default {
	name: 'form-handler',
	data: function data() {
		return {
			invalid: {
				//city: ['lorem']
			},

			isSended: false,
			isModalShowed: false,
			isBusy: false,
			isClear: false,
			clearFile: true,
			ajaxmessage: 'Сообщение'
		};
	},

	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		action: function action() {
			return this.$refs.form.getAttribute('action') || '/';
		},
		submitText: function submitText() {
			if (this.isSended) {

				return this.$lang('submitSuccess', null, this.lang);
			} else if (this.isBusy) {
				return this.$lang('submitWait', null, this.lang);
			} else {
				return this.$lang('submitSend', null, this.lang);
			}
		}
	},

	methods: {
		onFileChange: function onFileChange(data) {
			this.clearFile = false;
		},
		clearForm: function clearForm() {
			this.invalid = {};

			this.isSended = false;
			this.isBusy = false;
			this.isClear = true;
			this.clearFile = true;
		},
		closeForm: function closeForm() {
			this.isModalShowed = false;
		},
		sendForm: function sendForm() {
			var _this = this;

			if (this.isBusy) return false;

			var data = new FormData(this.$refs.form);
			var form = this.$refs.form;
			var goal = jquery(form).attr('data-ya-metrica-goal');
			if (goal) {
				yaCounter50339161.reachGoal(goal);
				//alert('goal: '+goal)
			}
			this.isSended = false;
			this.isClear = false;
			this.clearFile = false;
			this.isBusy = true;

			this.ajaxmessage = axios.post(this.action, data).then(function (res) {
				_this.clearForm();
				_this.isSended = true;
				_this.isModalShowed = true;
			}).catch(function (error) {
				_this.invalid = error.data.errors;
				_this.isBusy = false;
			});
		}
	},

	watch: {
		clear: function clear(val) {
			if (val) this.clearForm();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./components/mixins/form-handler.js
// module id = ./components/mixins/form-handler.js
// module chunks = 0 1 2